// 路由信息，纯JS对象，方便读取路由信息
const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */'./views/home.vue'),
    desc: 'home',
  },
  {
    path: '/donation',
    name: 'donation',
    component: () => import(/* webpackChunkName: "donation" */'./views/donation.vue'),
    desc: 'donation',
  },
  {
    path: '/ngo/:id',
    name: 'ngo',
    component: () =>  import(/* webpackChunkName: "ngo" */'./views/ngo.vue'),
    desc: 'ngo',
  },
  {
    path: '/past',
    name: 'past',
    component: () => import(/* webpackChunkName: "donation" */'./views/past.vue'),
    desc: 'past',
  },
];

export default {
  routes,
};
